import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import {
  ContainerModal,
  ListModal,
  ListItem,
  ListLinkModal,
  Button,
} from "./styles";

import { IoIosArrowDown } from "react-icons/io";

import {
  IMenuOption,
  menu as initialMenu,
  menuFinancial as initialMenuFinancial,
} from "./menu";
import { useMenu } from "../../contexts/menu";
import useDetectClickOutside from "../../hooks/detectClickOutside";
import { useFormModal } from "../../contexts/formModal";
import { useAuth } from "../../contexts/auth";

export interface ILeftSidebarProps {
  isExpanded: boolean;
  inactive: boolean;
}
interface IExtensionOption {
  id: string;
  opened: boolean | null;
  children?: Array<IExtensionOption>;
}

export interface IListLinkProps {
  level?: number;
  selected?: boolean;
  expanded?: string | null;
}

const ModalMenu: React.FC = () => {
  const {
    isLeftMenuOpen: isExpanded,
    setLeftMenuWidth: changeMenuWidth,
    toggleLeftMenu: toggleMenu,
  } = useMenu();
  const { user } = useAuth();
  const esconderDiretoria: string[] = [];
  const esconderUsuario: string[] = ["Usuários", "White List"];
  const history = useHistory();
  const location = useLocation();
  const menuRef = useRef<HTMLDivElement>(null);
  const [expansions, setExpansions] = useState<Array<IExtensionOption>>([]);
  const [_initialMenu, setInitialMenu] = useState<IMenuOption[]>([]);
  const [menu, setMenu] = useState<IMenuOption[]>([]);
  const [inactive, setInactive] = useState<boolean>(false);

  useDetectClickOutside(menuRef, () => {
    if (isExpanded) {
      toggleMenu();
    }
  });

  useEffect(() => {
    let baseMenu;
    const usuario = user as any;
    if (usuario) {
      const status = usuario.inativo;
      baseMenu = status === false ? initialMenu : initialMenuFinancial;
      setInactive(status);
    }
    if (usuario && baseMenu) {
      if (usuario.Login) {
        if (usuario.Login.nome === "Diretoria") {
          baseMenu = baseMenu.filter(
            (value) => !esconderDiretoria.includes(value.name)
          );
        } else {
          baseMenu = baseMenu.filter(
            (value) => !esconderUsuario.includes(value.name)
          );
        }
      } else {
        baseMenu = baseMenu.filter(
          (value) => !esconderUsuario.includes(value.name)
        );
      }
      setInitialMenu(baseMenu);
    }
  }, [user, initialMenu]);

  useLayoutEffect(() => {
    if (menuRef.current) {
      changeMenuWidth(menuRef.current.offsetWidth);
    }
  }, []);

  useEffect(() => {
    const baseOrderedMenu = _initialMenu.sort(compare);
    const secondOrderedMenu = baseOrderedMenu.map((menuOption) => {
      if (!menuOption.disabled && menuOption.children) {
        const menuChildrenOrdered = menuOption.children.sort(compare);
        return { ...menuOption, children: menuChildrenOrdered };
      } else {
        return menuOption;
      }
    });
    const thirdOrderedMenu = secondOrderedMenu.map((menuOption) => {
      if (!menuOption.disabled && menuOption.children) {
        const menuChildrenOrdered = menuOption.children.map(
          (secondMenuOption) => {
            if (!secondMenuOption.disabled && secondMenuOption.children) {
              const secondMenuChildrenOrdered =
                secondMenuOption.children.sort(compare);
              return {
                ...secondMenuOption,
                children: secondMenuChildrenOrdered,
              };
            } else {
              return secondMenuOption;
            }
          }
        );
        return { ...menuOption, children: menuChildrenOrdered };
      } else {
        return menuOption;
      }
    });

    setMenu(thirdOrderedMenu);
    handleExpansions(thirdOrderedMenu);
  }, [_initialMenu]);

  const handleNavigate = (path: string | undefined) => {
    if (path === undefined) return;
    toggleMenu();
    return history.push(path);
  };

  const handleExpansions = (menuOptions: Array<IMenuOption>) => {
    const options: Array<IExtensionOption> = menuOptions.map((option) => {
      if (option.children) {
        const secondMenuOptions = option.children.map((secondOption) => {
          if (secondOption.children) {
            const thirdMenuOptions = secondOption.children.map(
              (thirdOption) => {
                return { id: thirdOption.id, opened: null };
              }
            );
            return {
              id: secondOption.id,
              children: thirdMenuOptions,
              opened: false,
            };
          } else {
            return { id: secondOption.id, opened: null };
          }
        });

        return { id: option.id, opened: false, children: secondMenuOptions };
      } else {
        return { id: option.id, opened: null };
      }
    });

    setExpansions(options);
  };

  const handleOpenMenu = (
    firstId: string | null = null,
    secondId: string | null = null
  ) => {
    if (firstId) {
      let newExpansions;
      if (secondId) {
        newExpansions = expansions.map((option) => {
          if (option.id === firstId) {
            if (option.children) {
              const newSecondExpansions = option.children.map(
                (secondOption) => {
                  if (secondOption.id === secondId) {
                    return { ...secondOption, opened: !secondOption.opened };
                  } else {
                    return secondOption;
                  }
                }
              );
              return { ...option, children: newSecondExpansions };
            } else {
              return option;
            }
          } else {
            return option;
          }
        });
      } else {
        newExpansions = expansions.map((option) => {
          if (option.id === firstId) {
            if (option.children) {
              return { ...option, opened: !option.opened };
            } else {
              return option;
            }
          } else {
            return option;
          }
        });
      }

      setExpansions(newExpansions);
    } else {
      return;
    }
  };

  const compare = (a: IMenuOption, b: IMenuOption): number => {
    if (a.order < b.order) {
      return -1;
    }
    if (a.order > b.order) {
      return 1;
    }
    return 0;
  };

  const renderMenu = () => {
    if (expansions.length <= 0) {
      return;
    }

    const items = menu.map(
      ({ id, name, children, icon: Icon, disabled, path }, firstIndex) =>
        !disabled && (
          <ListItem key={id}>
            <ListLinkModal
              title={name}
              expanded={String(true)}
              selected={path === location.pathname}
              onClick={
                isExpanded
                  ? !children
                    ? () => handleNavigate(path)
                    : () => handleOpenMenu(id)
                  : toggleMenu
              }
            >
              {/* onClick={isExpanded && !children ? () => handleNavigate(path) : () => handleOpenMenu(id) }> */}
              {Icon && <Icon />}
              {isExpanded && name}
              {isExpanded && children && (
                <IoIosArrowDown className="arrow-down" />
              )}
            </ListLinkModal>
            {children && isExpanded && expansions[firstIndex].opened && (
              <ListModal isExpanded={isExpanded}>
                {children.map(
                  (secondMenuOption, secondIndex) =>
                    !secondMenuOption.disabled && (
                      <ListItem key={secondMenuOption.id} className="menu-item">
                        <ListLinkModal
                          title={secondMenuOption.name}
                          onClick={
                            !secondMenuOption.children
                              ? () => handleNavigate(secondMenuOption.path)
                              : () => handleOpenMenu(id, secondMenuOption.id)
                          }
                          selected={secondMenuOption.path === location.pathname}
                          level={2}
                        >
                          {secondMenuOption.name}
                          {isExpanded && secondMenuOption.children && (
                            <IoIosArrowDown className="arrow-down" />
                          )}
                        </ListLinkModal>
                        {secondMenuOption.children &&
                          isExpanded &&
                          expansions[firstIndex]?.children?.[secondIndex]
                            .opened && (
                            <ListModal isExpanded={isExpanded}>
                              {secondMenuOption.children.map(
                                (thirdMenuOption) =>
                                  !thirdMenuOption.disabled && (
                                    <ListItem key={thirdMenuOption.id}>
                                      <ListLinkModal
                                        title={thirdMenuOption.name}
                                        onClick={() =>
                                          handleNavigate(thirdMenuOption.path)
                                        }
                                        selected={
                                          thirdMenuOption.path ===
                                          location.pathname
                                        }
                                        level={3}
                                      >
                                        {thirdMenuOption.name}
                                      </ListLinkModal>
                                    </ListItem>
                                  )
                              )}
                            </ListModal>
                          )}
                      </ListItem>
                    )
                )}
              </ListModal>
            )}
          </ListItem>
        )
    );

    return items;
  };

  return (
    <ContainerModal
      isExpanded={isExpanded}
      // onMouseLeave={toggleMenu}
      ref={menuRef}
      inactive={inactive}
    >
      <ListModal isExpanded={isExpanded}>{renderMenu()}</ListModal>
      {/* {isExpanded && <Button variant="outlined">Configurar Menu</Button>} */}
    </ContainerModal>
  );
};

export default ModalMenu;
